export const FOOTER_LOGIN = [
  { name: 'footer.login.1' },
  { name: 'footer.login.2' },
  { name: 'footer.login.3' },
];

export const pruebaUploadFROMdevelop = '213123213123';
